export enum LeftNavigationItemType {
  Link = 1,
  ExternalLink = 2,
  TaggedLink = 3,
  Expandable = 4,
  ExternalTaggedLink = 5,
}
